module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/twitterx-e9cd4095966e092bb4c6860bf8c16206.svg";